import { FC } from "react";
import { SignUp } from "../../../../modules/authentication/sign-up/sign-up";

export const SignUpRoute: FC = () => {
    return (
        <SignUp />
    )
}